module.exports = __webpack_public_path__ + "img/chamois_tweed.3e047765.jpeg";